import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { editInput } from './editInput';

export const mergePhotoIntoPrefab = (
    prefabInput: GiftJson.Input<PhotoVariableInput>,
    userInput: GiftJson.Input<PhotoVariableInput>
): GiftJson.Input<any> => {

    const fromUser = userInput.value;

    if (fromUser.assetUrl) {
        return editInput(prefabInput, {
            status: fromUser.status,
            assetUrl: fromUser.assetUrl,
            cropBox: fromUser.cropBox,
            fileName: fromUser.fileName,
            imageWidth: fromUser.imageWidth,
            imageHeight: fromUser.imageHeight,
            filter: fromUser.filter
        });
    }

    return prefabInput;
};